// Possible responses from /recommendation api
export const RECOMMENDED_MARKETING_HUB = 'MARKETING';
export const RECOMMENDED_SALES_HUB = 'SALES';
export const RECOMMENDED_SERVICE_HUB = 'SERVICE';
export const RECOMMENDED_CMS_HUB = 'CMS';
export const RECOMMENDED_OPS_HUB = 'OPS';

// Not returned by the ML Model api so this will be removed
export const RECOMMENDED_UNSPECIFIED_HUB = 'UNSPECIFIED';